export default {
  main: {
    site_id: 1865769,
    availableLanguages: {
      '@replace': true,
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 2,
      },
      rum: {
        short: 'RO',
        name: 'Rom',
        region: 'Romania',
        order: 1,
      },
    },
    terminalMode: 'clientTransaction',
    logoSize: 'big',
    staffPassword: '995511',
    showCustomLockScreenMessages: true,
    enableTerminalBalancePolling: true,
    useCurrencySymbol: false,
  },
  defaultTerminalParams: {
    pid: 1865769,
    tid: 33412,
    token: 'AaDBHQ==',
    currency: 'RON',
  },
  dailyReportUnitsToShow: ['deposit', 'withdrawal'],
  env: {
    lang: 'rum',
  },
  lastTicketButtons: [
    {
      name: 'Deposit tickets',
      type: 'clientDepositTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Withdraw tickets',
      type: 'clientWithdrawTicket',
      hideOnRestrictMode: false,
    },
  ],
  financialButtons: [
    {
      type: 'dailyReport',
      name: 'Daily report',
    },
    {
      type: 'lastBills',
      name: 'Last bills',
    },
    {
      type: 'lastBills',
      name: 'Last bills',
    },
  ],
  routes: [
    {
      url: 'clientTransaction',
      enabled: true,
    },
  ],
};
